export default __webpack_public_path__ + "static/media/briefcase-job-img.fbe1e4c5.svg";